import {
  GET_REQUESTS,
  SET_REQUESTS,
  SET_UNREAD_REQUESTS,
  GET_REQUESTS_ERROR,
  RESET_REQUESTS,
  GET_NOTIFICATIONS,
  SET_NOTIFICATIONS,
  SET_UNREAD_NOTIFICATIONS,
  GET_NOTIFICATIONS_ERROR,
  RESET_NOTIFICATIONS,
  GET_COMMON_NOTIFICATIONS,
  SET_COMMON_NOTIFICATIONS,
  SET_UNREAD_COMMON_NOTIFICATIONS,
  GET_COMMON_NOTIFICATIONS_ERROR,
  RESET_COMMON_NOTIFICATIONS,
  SET_REQUEST_FILTERS,
  RESET_REQUEST_FILTERS
} from './types'
import { RESET_TOKEN, SET_ACTIVE_WORKSPACE } from 'utils/auth/types'

const initialRequestFilters = {
  status: null,
  assignee: null,
  dateRange: null
}

const initialState = {
  requests: [],
  requestsNext: null,
  isLoadingRequests: false,
  requestsUnreadCount: 0,
  notifications: [],
  notificationsNext: null,
  isLoadingNotifications: false,
  notificationsUnreadCount: 0,
  commonNotifications: [],
  commonNotificationsNext: null,
  isLoadingCommonNotifications: false,
  commonNotificationsUnreadCount: 0,
  requestFilters: initialRequestFilters,
  filtersWorkspaceId: null
}

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUESTS:
      return {
        ...state,
        isLoadingRequests: true
      }
    case SET_REQUESTS:
      return {
        ...state,
        requests: action.payload.requests,
        requestsNext: action.payload.requestsNext,
        requestsUnreadCount: action.payload.requestsUnreadCount,
        isLoadingRequests: false
      }
    case SET_UNREAD_REQUESTS:
      return {
        ...state,
        requestsUnreadCount: action.payload.requestsUnreadCount
      }
    case GET_REQUESTS_ERROR:
      return {
        ...state,
        isLoadingRequests: false
      }
    case RESET_REQUESTS:
      return {
        ...state,
        requests: [],
        isLoadingRequests: false
      }
    case GET_NOTIFICATIONS:
      return {
        ...state,
        isLoadingNotifications: true
      }
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload.notifications,
        notificationsNext: action.payload.notificationsNext,
        notificationsUnreadCount: action.payload.notificationsUnreadCount,
        isLoadingNotifications: false
      }
    case SET_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        notificationsUnreadCount: action.payload.notificationsUnreadCount
      }
    case GET_NOTIFICATIONS_ERROR:
      return {
        ...state,
        isLoadingNotifications: false
      }
    case RESET_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
        isLoadingNotifications: false
      }
    case GET_COMMON_NOTIFICATIONS:
      return {
        ...state,
        isLoadingCommonNotifications: true
      }
    case SET_COMMON_NOTIFICATIONS:
      return {
        ...state,
        commonNotifications: action.payload.commonNotifications,
        commonNotificationsNext: action.payload.commonNotificationsNext,
        commonNotificationsUnreadCount: action.payload.commonNotificationsUnreadCount,
        isLoadingCommonNotifications: false
      }
    case SET_UNREAD_COMMON_NOTIFICATIONS:
      return {
        ...state,
        commonNotificationsUnreadCount: action.payload.commonNotificationsUnreadCount
      }
    case GET_COMMON_NOTIFICATIONS_ERROR:
      return {
        ...state,
        isLoadingCommonNotifications: false
      }
    case RESET_COMMON_NOTIFICATIONS:
      return {
        ...state,
        commonNotifications: [],
        isLoadingCommonNotifications: false
      }
    case SET_REQUEST_FILTERS:
      return {
        ...state,
        requestFilters: {
          ...state.requestFilters,
          ...action.payload.filters
        }
      }
    case RESET_REQUEST_FILTERS:
      // The date range has its own button and clear badge, so clearing the
      // filter menu leaves it in place
      return {
        ...state,
        requestFilters: {
          ...initialRequestFilters,
          dateRange: state.requestFilters.dateRange
        }
      }
    case SET_ACTIVE_WORKSPACE: {
      const workspaceId = action.payload.activeWorkspace.id
      if (workspaceId === state.filtersWorkspaceId) {
        return state
      }
      return {
        ...state,
        requestFilters: initialRequestFilters,
        filtersWorkspaceId: workspaceId
      }
    }
    case RESET_TOKEN:
      return {
        ...state,
        requestFilters: initialRequestFilters,
        filtersWorkspaceId: null
      }
    default:
      return state
  }
}

export default notificationsReducer
